export default __webpack_public_path__ + "static/media/IMG_0815.d8467497.d8467497.JPG";